/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type {
	UserCheckPhoneRetrieveQueryCountryCode,
	UserCheckPhoneRetrieveQueryPhone,
	UserCheckPhoneRetrieveStatus200,
	UserCheckPhoneRetrieveStatus404,
} from "../types/UserCheckPhoneRetrieve.ts";

function getUserCheckPhoneRetrieveUrl() {
	const res = { method: "GET", url: `/api/user/check-phone` as const };

	return res;
}

/**
 * @description Проверка существования профиля пользователя в организации.
 * @summary проверка существования профиля пользователя
 * {@link /api/user/check-phone}
 */
export async function userCheckPhoneRetrieve(
	params: { country_code?: UserCheckPhoneRetrieveQueryCountryCode; phone: UserCheckPhoneRetrieveQueryPhone },
	config: Partial<RequestConfig> & { client?: Client } = {},
) {
	const { client: request = client, ...requestConfig } = config;

	const res = await request<UserCheckPhoneRetrieveStatus200, ResponseErrorConfig<UserCheckPhoneRetrieveStatus404>, unknown>({
		method: "GET",
		url: getUserCheckPhoneRetrieveUrl().url.toString(),
		params,
		...requestConfig,
	});

	return res.data;
}
